export default __webpack_public_path__ + "static/media/elevator-call.40ed8c87.png";